module.exports = __webpack_public_path__ + "img/more.28a80b92.svg";